import './button.css';

export default function CustomButton({ label, onClick, className }) {
  return (
    <button type="button" className={`button__container ${className}`} onClick={onClick}>
      {label}
    </button>
  );
}
